export default __webpack_public_path__ + "static/media/profile-setting.06ad0e30.svg";